export default __webpack_public_path__ + "static/media/pofhero.4893da8d.png";